export namespace OrganizationTypeCodeConstants {
  export const ADA_SUPPLEMENTAL_CODE = 'ADASUP';
  export const RIDER_CHOICE_CODE = 'RIDRCHC';
  export const FACILITY_CODE = 'FACILITY';
  export const COMMUNITY_MOBILITY_CODE = 'CMO';
}
